import { localStreamPIDs } from './liveVideo';

/**
 * isIframeVideo
 * @description Checks if a playmaker ID exists in a list of local stream PID
 * @param {string} playmakerId
 * @param {string} playmakerIdOverride
 * @returns {boolean}
 */
export const isIframeVideo = (playmakerId, playmakerIdOverride) => {
  const hasPlaymakerId = localStreamPIDs.includes(playmakerId);
  const hasPlaymakerIdOverride = localStreamPIDs.includes(playmakerIdOverride);
  const isOther = playmakerId === 'other';

  return hasPlaymakerId || (isOther && hasPlaymakerIdOverride);
};
